export default class Zipcode {
  code: string;
  data?: string;
}
